import React from "react";
import LayoutComp from "../../components/Layout/LayoutComp";

/**
 * @component  NotFoundPage
 * @description It will be redirect  to  not found page on unknown path
 * @returns NoFound Page
 */

const NotFoundPage = () => {
  return (
    <LayoutComp>
      <div className="pageNotFoundDiv">
        <h1>
          <img src="/Images/notFoundPage.png" alt="Not Found Page" />
        </h1>
      </div>
    </LayoutComp>
  );
};

export default NotFoundPage;
